import React from 'react';
import { TestResultsRenderer } from '../components/TestResultsRenderer';
import { Layout } from '../components/Layout';

interface TestResultsPageProps {
  title?: string;
  description?: string;
  pageTitle?: string;
  pageDescription?: string;
}

export const TestResultsPage: React.FC<TestResultsPageProps> = ({
  title = 'Test Results',
  description = 'Display of test results with detailed analysis and validation metrics',
  pageTitle,
  pageDescription,
}) => {
  return (
    <Layout>
      <div className="h-screen bg-allianz-light p-6 flex flex-col">
        <div className="flex-1 flex flex-col min-h-0">
          {(pageTitle || pageDescription) && (
            <div className="mb-8 flex-shrink-0">
              {pageTitle && (
                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                  {pageTitle}
                </h1>
              )}
              {pageDescription && (
                <p className="text-gray-600">{pageDescription}</p>
              )}
            </div>
          )}

          <div className="flex-1 min-h-0">
            <TestResultsRenderer title={title} description={description} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

// Backward compatibility export
export const HtmlTestResultsPage = TestResultsPage;
